import { render, staticRenderFns } from "./PassoFalecido.vue?vue&type=template&id=a59ae312&"
import script from "./PassoFalecido.vue?vue&type=script&lang=js&"
export * from "./PassoFalecido.vue?vue&type=script&lang=js&"
import style0 from "./PassoFalecido.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports